module.exports = __webpack_public_path__ + "img/default-tablet-english-no-content.1b35bc09.png";